import React from 'react'
import { useState ,useEffect} from 'react';
import { CryptoState } from '../CryptoContext';
import { useNavigate } from 'react-router-dom';
import { numberWithCommas } from './Banner/Carousel';
import { Pagination } from '@material-ui/lab';
import { makeStyles,Container, createTheme, ThemeProvider, Typography,TextField, 
    TableContainer ,LinearProgress, Table,TableRow,TableHead,TableCell, 
    TableBody } from '@material-ui/core';

const CoinsTable = () => {
  
  const [search, setSearch] = useState("");
  const { currency, symbol ,coins ,loading,fetchCoins } = CryptoState();
  const [page, setPage] = useState(1);
  const useStyles = makeStyles({
    row: {
      backgroundColor: "#028FA3",
      cursor: 
      "pointer",
      "&:hover": {
        backgroundColor: "#131111",
      },
      fontFamily: "Montserrat",
    },
    pagination: {
      "& .MuiPaginationItem-root": {
        color: "gold",
      },
    },
  });
  const classes = useStyles();
  const history = useNavigate();
  
  //console.log(coins)
  useEffect(() => {
    fetchCoins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currency]);
  const darkTheme = createTheme({
    palette: {
      primary: {
        main: "#fff",
      },
      type: "dark",
    },
  });
  const handleSearch = () => {
    return coins.filter(
      (coin) =>
      coin.name.toLowerCase().includes(search) || coin.symbol.toLowerCase().includes(search)
      );
    };
    return (
    <ThemeProvider theme={darkTheme}>
      <Container style={{textAlign:"center"}}>
        <Typography 
        variant="h4" 
        style={{ margin: 18, fontFamily: "Montserrat" }}
        >
          Cryptocurrency Prices by Market Cap
        </Typography>
        <TextField 
        label="Search For a Crypto Currency.."
        variant="outlined"
        style={{ marginBottom: 20, width: "100%" }}
        onChange={(e) => setSearch(e.target.value)}
        />
        <TableContainer>
          {/* when loading or making request */}
          {loading ? (<LinearProgress style={{ backgroundColor: "gold" }} /> ) : //  after loading
                        (    
                        <Table aria-label="simple table">
                          {/* table heading */}
                            <TableHead style={{ backgroundColor: "#EEBC1D" }}>
                              <TableRow>
                                {["Coin", "Price", "24h Change", "Market Cap"].map((head) => (
                                  <TableCell
                                    style={{
                                      color: "black",
                                      fontWeight: "700",
                                      fontFamily: "Montserrat",
                                    }}
                                    key={head}
                                    align={head === "Coin" ? "" : "right"}
                                  >
                                    {head}
                                  </TableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {/* searched data */}
                              {handleSearch().slice((page - 1) * 10, (page - 1) * 10 + 10)
                              .map((row) => {
                                const profit = row.price_change_percentage_24h > 0;
                                return (
                                <TableRow
                                onClick={() => history(`/coins/${row.id}`)}
                                className={classes.row}
                                key={row.name}
                                >
                                  <TableCell
                                  component="th"
                                  scope="row"
                                  style={{
                                    display: "flex",
                                    gap: 15,
                                  }}
                                  >
                                    <img 
                                    src={row?.image}
                                    alt={row.name}
                                    height="50"
                                    style={{ marginBottom: 10 }}
                                    />
                                    <div 
                                    style={{ display: "flex", flexDirection: "column" }}
                                    >
                                      <span
                                      style={{
                                        textTransform: "uppercase",
                                        fontSize: 22,
                                      }}
                                      >
                                        {row.symbol}
                                        </span>
                                        <span style={{ color: "darkgrey" }}>
                                          {row.name}
                                          </span>
                                          </div>
                                    </TableCell>
                                    <TableCell align="right">
                                      {symbol}{" "}{numberWithCommas(row.current_price.toFixed(2))}
                                      </TableCell>
                                      <TableCell 
                                      align="right"
                                      style={{
                                        color: profit > 0 ? "rgb(14, 203, 129)" : "red",
                                        fontWeight: 500,
                                      }}
                                      >
                                        {profit && "+"} {row.price_change_percentage_24h.toFixed(2)} %
                                        </TableCell>
                                        <TableCell align="right">
                                          {symbol}{" "}{numberWithCommas(row.market_cap.toString().slice(0, -6))}
                                        </TableCell>
                                </TableRow>
                                )})}
                                </TableBody>
                              </Table>
                              )}
                            </TableContainer>
                            {/* Comes from @material-ui/lab */}
                            <Pagination 
                            count={(handleSearch()?.length / 10).toFixed(0)}
                            style={{
                              padding: 20,
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                            classes={{ ul: classes.pagination }}
                            onChange={(_, value) => {
                              setPage(value);
                              window.scroll(0, 450);
                            }}
                            />
                          </Container>
                          </ThemeProvider>
                          )
                        }
                        
export default CoinsTable
